import React from 'react';
import { useAppSelector } from 'core/store';
import DashboardPieChart from 'pages/Dashboard/shared/DashboardPieChart';
import { prepareChartData } from '@dashboardWirelineRetentionDepartment/utilities';

interface IRenewedEngagementsChart {
    selectedProducts: string[]
}

const InProgressEngagementsChart: React.FC <IRenewedEngagementsChart> = (
  { selectedProducts },
) => {
  const inProgressEngagementsData = useAppSelector(
    (state) => state.dashboard.inProgressEngagements.data,
  );
  const isLoading = useAppSelector(
    (state) => state.dashboard.inProgressEngagements.isLoading,
  );

  const { chartData, colors } = prepareChartData(selectedProducts, inProgressEngagementsData);

  return (
    <DashboardPieChart
      colors={colors}
      data={chartData}
      isLoading={isLoading}
      innerRadius={60}
      paddingAngle={2}
    />
  );
};

export default InProgressEngagementsChart;
